export default "__VITE_ASSET__48a2626f__"